import React from "react";
import { View } from "react-native";

// Web版の広告枠。全社共通の広告枠(arista-ads)を結果の下に 1 枠だけ置く。
// 読み込みタグは build-web.mjs が index.html の </body> 直前へ入れ、中身(自社の商品・提携広告と「PR」表示)は
// slot.js が描く。出すものが無いときは slot.js が何も描かないので、空の箱は残らない。
// 2026-09-29: Google AdSense は撤去した(代表決定。広告は arista-ads に一本化)。
// このファイルは .web.js なので iOS アプリには含まれない(アプリ内の AdMob は AdBanner.native.js)。
export default function AdBanner({ style }) {
  return (
    <View style={[{ width: "100%", marginBottom: 12 }, style]}>
      <div data-arista-ad="bottom" style={{ width: "100%" }} />
    </View>
  );
}
